import generatedCatalog from "./allianceBuffCatalog.generated.json";

const normalizeEffect = (effect = {}) => {
  const effectId = Math.trunc(Number(effect?.effectId || 0));
  const value = Number(effect?.value || 0);
  if (!Number.isFinite(effectId) || effectId <= 0 || !Number.isFinite(value) || value === 0) return null;
  return { effectId, value };
};

export const ALLIANCE_BUFF_CATALOG = Array.isArray(generatedCatalog?.buffs)
  ? generatedCatalog.buffs.map((buff = {}) => ({
    itemGid: Math.trunc(Number(buff?.itemGid || 0)),
    name: String(buff?.name || "").trim(),
    category: String(buff?.category || "").trim(),
    categoryLabel: String(buff?.categoryLabel || "").trim(),
    target: String(buff?.target || "").trim(),
    durationSeconds: Math.max(0, Math.floor(Number(buff?.durationSeconds || 0))),
    durationLabel: String(buff?.durationLabel || "").trim(),
    description: String(buff?.description || "").trim(),
    effects: (Array.isArray(buff?.effects) ? buff.effects : []).map(normalizeEffect).filter(Boolean),
  })).filter((buff) => buff.itemGid > 0 && buff.name && buff.effects.length > 0)
  : [];

export default ALLIANCE_BUFF_CATALOG;
